import type { JSX } from 'react';
import React from 'react';

interface Props {
  children: string | number | undefined | JSX.Element;
  label: string | number | undefined | JSX.Element;
}

const OverLabel = ({ children, label }: Props): JSX.Element => {
  return (
    <div className="min-w-0 flex-auto">
      <div className="text-black text-base font-semibold mb-2">{label}</div>
      <div className="text-black text-base font-normal ">{children}</div>
    </div>
  );
};

export default OverLabel;
